import { Checkbox, Modal, Spacing, Text, TextLink, useDevice } from '@dls/web';
import React from 'react';
import styled from 'styled-components';
import theme from '../../theme';
import { trans as t } from '../../helpers/localisation';
import { KeyValue } from '../../types/common.types';
import { SimTransactionType } from '../../constants/choose-sim-type';
const PortInDetails = styled.div`
  p {
    margin-bottom: ${theme.spacing(3)};
  }
`;

export const ModalContent = () => {
  return (
    <Modal.Content>
      <PortInDetails>
        <Text type="body">Undertaking Agreement</Text>
        <Text type="body">
          1. I hereby confirm the information is true and correct.
        </Text>
        <Text type="body">
          2. I hereby consent to the release of all relevant information to a
          third party central number port service provider and/or Donor for
          purpose of receiving the Port-In services.
        </Text>
        <Text type="body">
          3. I understand that I have to inform Singtel Mobile if I decide to
          opt out of any promotional Add-on Services when they expire.
        </Text>
        <Text type="body">
          4. I acknowledge that the existing contract with the Donor is my
          responsibility and agree to pay to the Donor all outstanding charges
          including early termination charges (ETC), if any until successful
          commencement of the Port-In services with Singtel Mobile.
        </Text>
        <Text type="body">
          5. I agree that should a Port-In service request be rejected for any
          reason, I agree to attend to and resolve the issue(s) with the Donor
          or otherwise within fourteen (14) days from the date of this
          Undertaking.
        </Text>
        <Text type="body">
          6. I agree to pay Singtel Mobile, immediately on demand, the
          applicable Device Agreement ETC or special promotional related costs
          should I fail to resolve the dispute and successfully commence the
          Port-In services with Singtel Mobile.
        </Text>
        <Text type="body">
          7. I acknowledge that the above mentioned required date is a tentative
          start date of Port-In request. The effective start date/time will be
          communicated via SMS.
        </Text>
        <Text type="body">
          8. I agree to subscribe for the Port-In services provided by Singtel
          Mobile Singapore Pte. Ltd. (Singtel Mobile) upon the same terms and
          conditions concurrently agreed and accepted by me/us in relation to
          the application for mobile services.
        </Text>
      </PortInDetails>
    </Modal.Content>
  );
};

export const PortInEsimTnc = ({
  selectedProduct,
  transactionTypeValue,
  tncMessage,
  onChange,
  onTncClicked
}: {
  transactionTypeValue: SimTransactionType;
  selectedProduct: KeyValue;
  isEsimSelected;
  tncMessage: string;
  onChange: (isSelected: boolean) => void;
  onTncClicked: () => void;
}) => {
  const { isMobile } = useDevice();
  const isPortIn = transactionTypeValue === 'portIn';
  if (!isPortIn) {
    return null;
  }
  const hasProduct = !!selectedProduct;
  const tncContent = (
    <>
      <Text type="body">
        {t('PORT_IN_TNC_TEXT')}
        <TextLink onClick={onTncClicked} inline>
          {t('TNC')}
        </TextLink>
      </Text>
    </>
  );

  if (!hasProduct) {
    return tncContent;
  }

  return (
    <Spacing topBottom={isMobile ? 1 : 0}>
      <Checkbox.InputGroup error={tncMessage}>
        <Checkbox.Input
          error={!!tncMessage}
          onChange={(e: any, isSelected: boolean) => {
            onChange(isSelected);
          }}
          label={
            <>
              <Text tag={'span'}>{t('PORT_IN_CHECKBOX_TEXT')}</Text>
              <Text tag={'span'} type={'boldBody'}>
                {t('PORT_IN_CHECKBOX_TEXT_BOLD')}
              </Text>
              <Spacing top={1}>{tncContent}</Spacing>
            </>
          }
        />
      </Checkbox.InputGroup>
    </Spacing>
  );
};
